export default __webpack_public_path__ + "static/media/tz.e43e892a.svg";